"use client";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import Icon from "../../common/components/Icon";
import { Link } from "../../../navigation";
import useCurrentUser from "../../auth/hooks/useCurrentUser";
import useCMSInfoText from "../hooks/useCMSInfoText";
import { useLocale } from "next-intl";
import useCMSPageByID from "../hooks/server/useCMSPageByID";

const InfoTextLink = ({ url, children }) => {
  const pageId = typeof url === "string" ? url?.split("pages://")?.[1] : null;
  const locale = useLocale();
  const { page, loading } = useCMSPageByID({ pageId, locale });

  if (loading) return children;
  return (
    <Link href={page?._r || url} lang={locale}>
      {children}
    </Link>
  );
};

const stampInfoTextWithCurrentDate = (id, userId) => {
  const date = new Date();
  return [
    userId || "",
    id,
    date.getDate(),
    date.getMonth() + 1,
    date.getFullYear(),
  ]
    .filter(Boolean)
    .join("");
};
const InfoText = () => {
  const [closedInfoTexts, setClosedInfoTexts] = useState([]);
  const { currentUser } = useCurrentUser();
  const { messages } = useCMSInfoText();

  useEffect(() => {
    if (messages?.length && localStorage) {
      setClosedInfoTexts(
        JSON.parse(localStorage.getItem("closedInfoTexts") || "[]"),
      );
    }
  }, [messages?.length]);

  const closeInfoText = useCallback(
    (id) => {
      const updatedClosedTexts = [
        ...new Set([
          ...closedInfoTexts,
          stampInfoTextWithCurrentDate(id, currentUser?._id),
        ]),
      ];
      localStorage.setItem(
        "closedInfoTexts",
        JSON.stringify(updatedClosedTexts),
      );
      setClosedInfoTexts(updatedClosedTexts);
    },
    [currentUser],
  );

  const visibleInfoTexts = useMemo(
    () =>
      messages?.filter(({ _id, closable }) => {
        if (!closable) return true;
        return !closedInfoTexts.includes(
          stampInfoTextWithCurrentDate(_id, currentUser?._id),
        );
      }),
    [messages, currentUser],
  );

  if (!visibleInfoTexts?.length) return null;

  return visibleInfoTexts.map(({ _id, closable, ...message }) => (
    <div
      key={_id}
      id="infotext"
      className={classNames("text-center p-2 font-weight-bold")}
      style={{
        zIndex: 1090,
        textWrap: "balance",
        background: message?.backgroundColor || "#FFFFFF",
        color: message?.textColor
          ? message?.textColor
          : message?.backgroundColor && message?.backgroundColor !== "#FFFFFF"
            ? "#FFFFFF"
            : "#003a4f",
      }}
    >
      <div className="container px-4 position-relative">
        {closable && (
          <button
            onClick={() => closeInfoText(_id)}
            type="button"
            aria-label="close info text"
            className="position-absolute d-flex align-items-center"
            style={{
              top: "50%",
              right: "0.25rem",
              transform: "translateY(-50%)",
            }}
          >
            <Icon icon="close" className="icon--sm" fill="currentColor" />
          </button>
        )}
        {message?.link ? (
          <InfoTextLink url={message.link}>{message?.text}</InfoTextLink>
        ) : (
          message?.text
        )}
      </div>
    </div>
  ));
};

export default InfoText;
